import axios from "axios";
import { getBackendUrl } from "../utils/backendUrl";

const baseURL = getBackendUrl();

const api = axios.create({
	baseURL,
	withCredentials: true,
	timeout: 10000,
});

export const openApi = axios.create({
	baseURL,
	timeout: 10000,
});

export default api;
